import { createAction, props } from '@ngrx/store';

export const getAllLoginLogs = createAction(
  '[Administrator/API] Get users login logs list',
  props<{ usersLoginLogsPayload: any }>()
);
export const getAllLoginLogsSuccess = createAction(
  '[Administrator/API] Get users login logs success',
  props<{ usersLoginLogsList: any }>()
);
export const getAllLoginLogsFailure = createAction(
  '[Administrator/API] Get users login logs failure',
  props<{ error: any }>()
);

//Action for opening add/edit Login Logsmodal
export const openLoginLogsModal = createAction(
  '[Administrator/API] Open  login logs Modal',
  props<{ loginLogsId?: any; actionLabel: any; columnData: any }>()
);
export const openLoginLogsModalSuccess = createAction(
  '[Administrator/API] Open login logs Modal success',
  props<{ loginLogsHistoryData?: any }>()
);

//Action for get login history
export const getAllLoginLogsHistory = createAction(
  '[Administrator/API] Get users login logs history list',
  props<{ usersLoginLogsHistoryPayload: any; userId: any }>()
);
export const getAllLoginLogsHistorySuccess = createAction(
  '[Administrator/API] Get users login logs history success',
  props<{ loginLogsHistoryData: any }>()
);
export const getAllLoginLogsHistoryFailure = createAction(
  '[Administrator/API] Get users login logs history failure',
  props<{ error: any }>()
);

//Action for Admin Organization
export const getAdminOrganizationData = createAction(
  '[Administrator/API] Get admin organization data',
  props<{ adminOrganizationPayload: any }>()
);
export const getAdminOrganizationDataSuccess = createAction(
  '[Administrator/API] Get admin organization data success',
  props<{ adminOrganizationData: any }>()
);
export const getAdminOrganizationDataFailure = createAction(
  '[Administrator/API] Get admin organization data failure',
  props<{ error: any }>()
);
export const clearAdminOrganization = createAction('[Administrator/API] clear admin organization ');

//Action for Admin Organization Modal
export const openAddEditAdminOrganizationModal = createAction(
  '[Administrator/API] Open Add edit admin organization Modal',
  props<{ organizationId?: any; actionLabel: any }>()
);
export const openAddEditAdminOrganizationModalSuccess = createAction(
  '[Administrator/API] Open Add edit  admin organization Modal success',
  props<{ adminOrganizationModaldata?: any }>()
);

// add edit admin organization
export const addEditAdminOrganization = createAction(
  '[Administrator/API] Add editadmin organization ',
  props<{ adminOrganization: any }>()
);
export const addEditAdminOrganizationSuccess = createAction(
  '[Administrator/API] Add edit admin organization  success',
  props<{ adminOrganization: any }>()
);
export const addEditAdminOrganizationFailure = createAction(
  '[Administrator/API] Add edit admin organization  failure',
  props<{ error: any }>()
);

// delete admin organization
export const deleteAdminOrganizationData = createAction(
  '[Administrator/API] delete Admin organization data',
  props<{ organizationId: any }>()
);
export const deleteAdminOrganizationDataSuccess = createAction(
  '[Administrator/API] Admin organization data Success',
  props<{ deleteAdminOrganizationDataMessage: any }>()
);
export const deleteAdminOrganizationDataFailure = createAction(
  '[Administrator/API] Admin organization data Failure',
  props<{ error: any }>()
);

//Action for delete Data custom component
export const deleteOrganization = createAction(
  '[Administrator/API] deleteOrganization',
  props<{ action: any; customType: any; pathName: any }>()
);

// Action for delete Custom Material
export const deleteOrganizationData = createAction(
  '[Administrator/API] deleteOrganizationData',
  props<{ payload: any; customType: any; pathName: any }>()
);
export const deleteOrganizationDataSuccess = createAction(
  '[Administrator/API] deleteOrganizationData Success',
  props<{ deleteOrganizationDataMessage: any }>()
);
export const deleteOrganizationDataFailure = createAction(
  '[Administrator/API] deleteOrganizationData Failure',
  props<{ error: any }>()
);
// inline edit admin organization
export const inlineDataEditForAdminOrganization = createAction(
  '[Administrator/API] Inline  edit admin organization edit',
  props<{ adminOrganization: any }>()
);
export const inlineDataEditForAdminOrganizationSuccess = createAction(
  '[Administrator/API] Inline  edit admin organization edit success',
  props<{ organizationData: any }>()
);
export const inlineDataEditForAdminOrganizationFailure = createAction(
  '[Administrator/API] Inline  edit admin organization edit failure',
  props<{ error: any }>()
);

// Processing Data Conversion
export const getConversionList = createAction(
  '[Administrator/API] getConversionList',
  props<{ payload: any; pathName?: any }>()
);
export const getConversionListSuccess = createAction(
  '[Administrator/API] getConversionList Success',
  props<{ conversionList: any }>()
);
export const getConversionListFailure = createAction(
  '[Administrator/API] getConversionList Failure',
  props<{ error: any }>()
);

//Action for conversion Modal
export const openAddEditConversionModal = createAction(
  '[Administrator/API] Open Add edit conversion Modal',
  props<{
    organizationId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
    modalName: any;
  }>()
);
export const openAddEditConversionModalSuccess = createAction(
  '[Administrator/API] Open Add edit conversion Modal success',
  props<{ conversionModaldata?: any }>()
);

// add edit conversion
export const addEditProcessingConversion = createAction(
  '[Administrator/API] Add edit conversion  ',
  props<{ conversion: any }>()
);
export const addEditProcessingConversionSuccess = createAction(
  '[Administrator/API] Add edit conversion   success',
  props<{ processignConversion: any }>()
);
export const addEditProcessingConversionFailure = createAction(
  '[Administrator/API] Add edit conversion   failure',
  props<{ error: any }>()
);
// Action for ingredients in Data Management -> Recycled Material
export const getRecycledMaterialList = createAction(
  '[Administrator/API] Get Recycled Material list',
  props<{ recycledMaterialPayload: any }>()
);
export const getRecycledMaterialListSuccess = createAction(
  '[Administrator/API] Get Recycled Material success',
  props<{ recycledMaterialList: any }>()
);
export const getRecycledMaterialListFailure = createAction(
  '[Administrator/API] Get Recycled Material failure',
  props<{ error: any }>()
);

// Action for material in Data Management -> Material Impact Data
export const getMaterialList = createAction(
  '[Administrator/API] Get materials list',
  props<{ materialsPayload: any }>()
);
export const getMaterialListSuccess = createAction(
  '[Administrator/API] Get materials success',
  props<{ materialsList: any }>()
);
export const getMaterialListFailure = createAction(
  '[Administrator/API] Get materials failure',
  props<{ error: any }>()
);

// Action for ingredients in Data Management -> Material Impact Data
export const getIngredientsList = createAction(
  '[Administrator/API] Get ingredients list',
  props<{ ingredientsPayload: any }>()
);
export const getIngredientsListSuccess = createAction(
  '[Administrator/API] Get ingredients success',
  props<{ ingredientsList: any }>()
);
export const getIngredientsListFailure = createAction(
  '[Administrator/API] Get ingredients failure',
  props<{ error: any }>()
);

//Action for Admin Organization Modal
export const openAddEditAdminMaterialsModal = createAction(
  '[Administrator/API] Open Add edit material organization Modal',
  props<{ id?: any; regionId: any; actionLabel: any }>()
);
export const openAddEditAdminMaterialsModalSuccess = createAction(
  '[Administrator/API] Open Add edit material organization Modal success',
  props<{ adminMaterialModaldata?: any }>()
);

// add edit admin materials
export const addEditAdminMaterial = createAction(
  '[Administrator/API] Add edit admin material ',
  props<{ adminMaterial: any }>()
);
export const addEditAdminMaterialSuccess = createAction(
  '[Administrator/API] Add edit admin material success',
  props<{ adminMaterial: any }>()
);
export const addEditAdminMaterialFailure = createAction(
  '[Administrator/API] Add edit admin material failure',
  props<{ error: any }>()
);

//Action for Admin Organization Modal
export const openAddEditAdminIngredientsModal = createAction(
  '[Administrator/API] Open Add edit ingredients organization Modal',
  props<{ id?: any; regionId: any; actionLabel: any }>()
);
export const openAddEditAdminIngredientsModalSuccess = createAction(
  '[Administrator/API] Open Add edit ingredients organization Modal success',
  props<{ adminIngredientModaldata?: any }>()
);

// add edit admin ingredients
export const addEditAdminIngredients = createAction(
  '[Administrator/API] Add edit ingredients material ',
  props<{ adminIngredient: any }>()
);
export const addEditAdminIngredientsSuccess = createAction(
  '[Administrator/API] Add edit admin ingredients success',
  props<{ adminIngredient: any }>()
);
export const addEditAdminIngredientsFailure = createAction(
  '[Administrator/API] Add edit admin ingredients failure',
  props<{ error: any }>()
);

//Action for Admin Recycled Modal
export const openAddEditAdminRecycledModal = createAction(
  '[Administrator/API] Open Add edit Recycled organization Modal',
  props<{ id?: any; regionId: any; actionLabel: any }>()
);
export const openAddEditAdminRecycledModalSuccess = createAction(
  '[Administrator/API] Open Add edit Recycled organization Modal success',
  props<{ adminRecycledModaldata?: any }>()
);

// add edit admin Recycled
export const addEditAdminRecycled = createAction(
  '[Administrator/API] Add edit Recycled material ',
  props<{ adminRecycled: any }>()
);
export const addEditAdminRecycledSuccess = createAction(
  '[Administrator/API] Add edit admin Recycled success',
  props<{ adminRecycled: any }>()
);
export const addEditAdminRecycledFailure = createAction(
  '[Administrator/API] Add edit admin Recycled failure',
  props<{ error: any }>()
);

// Processing Data area based conversion
export const getAreaBasedConversionList = createAction(
  '[Administrator/API] getAreaBasedConversionList',
  props<{ payload: any; pathName?: any }>()
);
export const getAreaBasedConversionListSuccess = createAction(
  '[Administrator/API] getAreaBasedConversionList Success',
  props<{ areaBasedConversionList: any }>()
);
export const getAreaBasedConversionListFailure = createAction(
  '[Administrator/API] getAreaBasedConversionList Failure',
  props<{ error: any }>()
);

//Action for area based  conversion Modal
export const openAddEditAreaBasedConversionModal = createAction(
  '[Administrator/API] Open Add edit area based conversion Modal',
  props<{
    organizationId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddEditAreaBasedConversionModalSuccess = createAction(
  '[Administrator/API] Open Add edit  area based  conversion Modal success',
  props<{ areaBasedConversionModaldata?: any }>()
);

// add edit conversion
export const addEditAreaBasedConversion = createAction(
  '[Administrator/API] Add edit area based conversion  ',
  props<{ conversion: any }>()
);
export const addEditAreaBasedConversionSuccess = createAction(
  '[Administrator/API] Add  area based   edit conversion   success',
  props<{ areaBasedConversion: any }>()
);
export const addEditAreaBasedConversionFailure = createAction(
  '[Administrator/API] Add edit  area based  conversion   failure',
  props<{ error: any }>()
);

// Processing Data Energy And Ancillary
export const getEnergyandAncillaryList = createAction(
  '[Administrator/API] getEnergyandAncillaryList',
  props<{ payload: any; pathName?: any }>()
);
export const getEnergyandAncillaryListSuccess = createAction(
  '[Administrator/API] getEnergyandAncillaryList Success',
  props<{ energyandAncillaryList: any }>()
);
export const getEnergyandAncillaryListFailure = createAction(
  '[Administrator/API] getEnergyandAncillaryList Failure',
  props<{ error: any }>()
);

//Action for Energy And Ancillary Modal
export const openAddEditEnergyandAncillaryModal = createAction(
  '[Administrator/API] Open Add edit energy and ancillary Modal',
  props<{
    energyProcessId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddEditEnergyandAncillaryModalSuccess = createAction(
  '[Administrator/API] Open Add edit  energy and ancillary Modal success',
  props<{ energyandAncillaryModalData?: any }>()
);

// add edit Energy And Ancillary
export const addEditEnergyandAncillary = createAction(
  '[Administrator/API] Add edit energy and ancillary  ',
  props<{ energyAncillary: any }>()
);
export const addEditEnergyandAncillarySuccess = createAction(
  '[Administrator/API] Add edit  energy and ancillary   success',
  props<{ energyAncillaryData: any }>()
);
export const addEditEnergyandAncillaryFailure = createAction(
  '[Administrator/API] Add edit energy and ancillary  failure',
  props<{ error: any }>()
);
// Processing Data transport
export const getTransportList = createAction(
  '[Administrator/API] getTransportList',
  props<{ payload: any; pathName?: any }>()
);
export const getTransportListSuccess = createAction(
  '[Administrator/API] getTransportList Success',
  props<{ transportList: any }>()
);
export const getTransportListFailure = createAction(
  '[Administrator/API] getTransportList Failure',
  props<{ error: any }>()
);

//Action for transport Modal
export const openAddEditTransportModal = createAction(
  '[Administrator/API] Open Add edit transport Modal',
  props<{
    transportModeId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddEditTransportModalSuccess = createAction(
  '[Administrator/API] Open Add edit  transport Modal success',
  props<{ transportModalData?: any }>()
);

// add edit transport
export const addEditTransport = createAction(
  '[Administrator/API] Add edit transport  ',
  props<{ transport: any }>()
);
export const addEditTransportSuccess = createAction(
  '[Administrator/API] Add edit  transport   success',
  props<{ transportData: any }>()
);
export const addEditTransportFailure = createAction(
  '[Administrator/API] Add edit transport  failure',
  props<{ error: any }>()
);

// Processing Data Custom Conversion
export const getProcessingCustomConversionList = createAction(
  '[Administrator/API] getProcessingCustomConversionList',
  props<{ payload: any; pathName?: any }>()
);
export const getProcessingCustomConversionListSuccess = createAction(
  '[Administrator/API] getProcessingCustomConversionList Success',
  props<{ processingCustomConversionList: any }>()
);
export const getProcessingCustomConversionListFailure = createAction(
  '[Administrator/API] getProcessingCustomConversionList Failure',
  props<{ error: any }>()
);

//Action for Custom Conversion Modal
export const openAddEditProcessingCustomConversionModal = createAction(
  '[Administrator/API] Open Add edit processing custom conversion Modal',
  props<{
    energyProcessId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddEditProcessingCustomConversionModalSuccess = createAction(
  '[Administrator/API] Open Add edit processing custom conversion  Modal success',
  props<{ ProcessingCustomConversionModalData?: any }>()
);

// add edit Custom Conversion
export const addEditProcessingCustomConversion = createAction(
  '[Administrator/API] Add edit processing custom conversion   ',
  props<{ processingCustomConversion: any }>()
);
export const addEditProcessingCustomConversionSuccess = createAction(
  '[Administrator/API] Add edit processing custom conversion success',
  props<{ processingCustomConversionData: any }>()
);
export const addEditProcessingCustomConversiontFailure = createAction(
  '[Administrator/API] Add edit processing custom conversion   failure',
  props<{ error: any }>()
);

// Processing Data Storage
export const getStorageList = createAction(
  '[Administrator/API] getStorageList',
  props<{ payload: any; pathName?: any }>()
);
export const getStorageListSuccess = createAction(
  '[Administrator/API] getStorageList Success',
  props<{ storageList: any }>()
);
export const getStorageListFailure = createAction(
  '[Administrator/API] getStorageList Failure',
  props<{ error: any }>()
);

//Action for Custom Conversion Modal
export const openAddEditStorageModal = createAction(
  '[Administrator/API] Open Add edit processing storage Modal',
  props<{ storageId?: any; actionLabel: any; pathName: any; regionId: any }>()
);
export const openAddEditStorageModalSuccess = createAction(
  '[Administrator/API] Open Add edit processing storage Modal success',
  props<{ storageModalData?: any }>()
);
// add edit Custom Conversion
export const addEditStorage = createAction(
  '[Administrator/API] Add edit processing storage',
  props<{ storage: any }>()
);
export const addEditStorageSuccess = createAction(
  '[Administrator/API] Add edit processing storage success',
  props<{ storageData: any }>()
);
export const addEditStorageFailure = createAction(
  '[Administrator/API] Add edit processing Storage failure',
  props<{ error: any }>()
);
// Processing Data waste
export const getWasteList = createAction(
  '[Administrator/API] getWasteList',
  props<{ payload: any; pathName?: any }>()
);
export const getWasteListSuccess = createAction(
  '[Administrator/API] getWasteList Success',
  props<{ wasteList: any }>()
);
export const getWasteListFailure = createAction(
  '[Administrator/API] getWasteList Failure',
  props<{ error: any }>()
);
//Action for waste Modal
export const openAddEditWasteModal = createAction(
  '[Administrator/API] Open Add edit waste Modal',
  props<{ wasteId?: any; actionLabel: any; pathName: any; regionId: any }>()
);
export const openAddEditWasteModalSuccess = createAction(
  '[Administrator/API] Open Add edit  waste Modal success',
  props<{ wasteModalData?: any }>()
);
// add edit waste
export const addEditWaste = createAction(
  '[Administrator/API] Add edit waste  ',
  props<{ waste: any }>()
);
export const addEditWasteSuccess = createAction(
  '[Administrator/API] Add edit  waste   success',
  props<{ wasteData: any }>()
);
export const addEditWasteFailure = createAction(
  '[Administrator/API] Add edit waste  failure',
  props<{ error: any }>()
);
// Processing Data refrigerated truck
export const getRefrigeratedTruckList = createAction(
  '[Administrator/API] getRefrigeratedTruckList',
  props<{ payload: any; pathName?: any }>()
);
export const getRefrigeratedTruckListSuccess = createAction(
  '[Administrator/API] getRefrigeratedTruckList Success',
  props<{ refrigeratedTruckList: any }>()
);
export const getRefrigeratedTruckListFailure = createAction(
  '[Administrator/API] getRefrigeratedTruckList Failure',
  props<{ error: any }>()
);
//Action for waste Modal
export const openAddEditRefrigeratedTruckModal = createAction(
  '[Administrator/API] Open Add edit refrigerated truck Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditRefrigeratedTruckModalSuccess = createAction(
  '[Administrator/API] Open Add edit  refrigerated truck Modal success',
  props<{ refrigeratedTruckModalData?: any }>()
);
// add edit waste
export const addEditRefrigeratedTruck = createAction(
  '[Administrator/API] Add edit refrigerated truck  ',
  props<{ refrigeratedTruck: any }>()
);
export const addEditRefrigeratedTruckSuccess = createAction(
  '[Administrator/API] Add edit  refrigerated truck success',
  props<{ refrigeratedTruckData: any }>()
);
export const addEditRefrigeratedTruckFailure = createAction(
  '[Administrator/API] Add edit refrigerated truck failure',
  props<{ error: any }>()
);
// Processing Data custom truck
export const getProcessingCustomTruckList = createAction(
  '[Administrator/API] getProcessingCustomTruckList',
  props<{ payload: any; pathName?: any }>()
);
export const getProcessingCustomTruckListSuccess = createAction(
  '[Administrator/API] getProcessingCustomTruckList Success',
  props<{ processingCustomTruckList: any }>()
);
export const getProcessingCustomTruckListFailure = createAction(
  '[Administrator/API] getProcessingCustomTruckList Failure',
  props<{ error: any }>()
);
//Action for waste Modal
export const openAddEditProcessingCustomTruckModal = createAction(
  '[Administrator/API] Open Add edit processing custon truck Modal',
  props<{ truckId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditProcessingCustomTruckModalSuccess = createAction(
  '[Administrator/API] Open Add edit  processing custon  truck Modal success',
  props<{ processingCustomTruckModalData?: any }>()
);
// add edit waste
export const addEditProcessingCustomTruck = createAction(
  '[Administrator/API] Add edit processing custom truck  ',
  props<{ processingCustomTruck: any }>()
);
export const addEditProcessingCustomTruckSuccess = createAction(
  '[Administrator/API] Add edit  processing custom  truck success',
  props<{ processingCustomTruckData: any }>()
);
export const addEditProcessingCustomTruckFailure = createAction(
  '[Administrator/API] Add edit processing custom  truck failure',
  props<{ error: any }>()
);

//Actions for EOL List
export const getEolList = createAction(
  '[Administrator/API] Get EOL list',
  props<{ eolPayload: any }>()
);
export const getEolListSuccess = createAction(
  '[Administrator/API] Get EOL success',
  props<{ eolList: any }>()
);
export const getEolListFailure = createAction(
  '[Administrator/API] Get EOL failure',
  props<{ error: any }>()
);

// add edit EOL
export const addEditEol = createAction(
  '[Administrator/API] Add edit EOL',
  props<{ eolPayload: any; pathName: any }>()
);
export const addEditEolSuccess = createAction(
  '[Administrator/API] Add edit EOL success',
  props<{ eolData: any }>()
);
export const addEditEolFailure = createAction(
  '[Administrator/API] Add edit EOL failure',
  props<{ error: any }>()
);

//Action for EOL
export const openAddEditEolModal = createAction(
  '[Administrator/API] Open Add edit EOL Modal',
  props<{
    id?: any;
    regionId?: any;
    actionLabel: any;
    pathName: any;
    endPoint: any;
    addEditEndpoint: any;
  }>()
);
export const openAddEditEolModalSuccess = createAction(
  '[Administrator/API] Open Add edit EOL Modal success',
  props<{ eolModalData?: any }>()
);

export const deleteEol = createAction(
  '[Administrator/API] delete EOL data',
  props<{ successMsg: any }>()
);

// other Data material types
export const getOtherDataMaterialList = createAction(
  '[Administrator/API] getOtherDataMaterialList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataMaterialListSuccess = createAction(
  '[Administrator/API] getOtherDataMaterialList Success',
  props<{ otherDataMaterialList: any }>()
);
export const getOtherDataMaterialListFailure = createAction(
  '[Administrator/API] getOtherDataMaterialList Failure',
  props<{ error: any }>()
);
//Action other Data material types
export const openAddEditOtherDataMaterialModal = createAction(
  '[Administrator/API] Open Add edi other data material Modal',
  props<{ materialId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditOtherDataMaterialModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data material Modal success',
  props<{ otherDataMaterialModalData?: any }>()
);

// add edit other data material For material-types & Recyclability & Compostability & Combustibility
export const addEditOtherDataMaterial = createAction(
  '[Administrator/API] Add edit other data material',
  props<{ otherMaterialPayload: any }>()
);
export const addEditOtherDataMaterialSuccess = createAction(
  '[Administrator/API] Add edit  other data success',
  props<{ otherMaterialData: any }>()
);
export const addEditOtherDataMaterialFailure = createAction(
  '[Administrator/API] Add edit other data failure',
  props<{ error: any }>()
);

// other Data CircularEconomyParameter
export const getOtherDataCircularEconomyParameterList = createAction(
  '[Administrator/API]  OtherData CircularEconomy ParameterList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataCircularEconomyParameterListSuccess = createAction(
  '[Administrator/API] OtherData CircularEconomy ParameterList Success',
  props<{ otherDataCircularEconomyParameterList: any }>()
);
export const getOtherDataCircularEconomyParameterListFailure = createAction(
  '[Administrator/API] OtherData CircularEconomy ParameterList Failure',
  props<{ error: any }>()
);
//Action other Data material types
export const openAddEditCircularEconomyParameterModal = createAction(
  '[Administrator/API] Open Add edi other data CircularEconomyParameter Modal',
  props<{ materialId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCircularEconomyParameterModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data CircularEconomyParameter Modal success',
  props<{ circularEconomyParameterModalData?: any }>()
);

// add edit other data material For material-types & Recyclability & Compostability & Combustibility
export const addEditOtherDataCircularEconomyParameter = createAction(
  '[Administrator/API] Add edit other data CircularEconomyParameter',
  props<{ otherCircularEconomyParameterPayload: any }>()
);
export const addEditOtherDataCircularEconomyParameterSuccess = createAction(
  '[Administrator/API] Add edit  other CircularEconomyParameter success',
  props<{ otherCircularEconomyParameterData: any }>()
);
export const addEditOtherDataCircularEconomyParameterFailure = createAction(
  '[Administrator/API] Add edit other CircularEconomyParameter failure',
  props<{ error: any }>()
);

// other Data PalletType
export const getOtherDataPalletTypeList = createAction(
  '[Administrator/API] getOtherDataPalletTypeList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataPalletTypeListSuccess = createAction(
  '[Administrator/API] getOtherDataPalletTypeList Success',
  props<{ otherDataPalletTypeList: any }>()
);
export const getOtherDataPalletTypeListFailure = createAction(
  '[Administrator/API] getOtherDataPalletTypeList Failure',
  props<{ error: any }>()
);
//Action other Data material types
export const openAddEditPalletTypeModal = createAction(
  '[Administrator/API] Open Add edi other data PalletType Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditPalletTypeModalModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data PalletType Modal success',
  props<{ palletTypeModalModalData?: any }>()
);

export const addEditOtherDataPalletType = createAction(
  '[Administrator/API] Add edit other data PalletType ',
  props<{ palletTypePayload: any }>()
);
export const addEditOtherDataPalletTypeSuccess = createAction(
  '[Administrator/API] Add edit  other PalletType  success',
  props<{ palletTypeData: any }>()
);
export const addEditOtherDataPalletTypeFailure = createAction(
  '[Administrator/API] Add edit other PalletType  failure',
  props<{ error: any }>()
);

// other Data Project Status
export const getOtherDataProjectstatusList = createAction(
  '[Administrator/API] getOtherDataProjectstatusList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataProjectstatusListSuccess = createAction(
  '[Administrator/API] getOtherDataProjectstatusList Success',
  props<{ otherDataProjectStatusList: any }>()
);
export const getOtherDataProjectstatusListFailure = createAction(
  '[Administrator/API] getOtherDataProjectstatusList Failure',
  props<{ error: any }>()
);
//Action other Data material types
export const openAddEditProjectstatusModal = createAction(
  '[Administrator/API] Open Add edi other data Project Status Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditProjectstatusModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data  Project Status Modal success',
  props<{ projectStatusModalData?: any }>()
);

export const addEditOtherDataProjectStatus = createAction(
  '[Administrator/API] Add edit other data Project Status ',
  props<{ projectStatusPayload: any }>()
);
export const addEditOtherDataProjectStatusSuccess = createAction(
  '[Administrator/API] Add edit  other Project Status  success',
  props<{ projectStatusData: any }>()
);
export const addEditOtherDataProjectStatusFailure = createAction(
  '[Administrator/API] Add edit other Project Status  failure',
  props<{ error: any }>()
);

// other Data Scenario Status
export const getOtherDataScenarioStatusList = createAction(
  '[Administrator/API] getOtherDataScenarioStatusList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataScenarioStatusListSuccess = createAction(
  '[Administrator/API] getOtherDataScenarioStatusList Success',
  props<{ otherDataScenarioStatusList: any }>()
);
export const getOtherDataScenarioStatusListFailure = createAction(
  '[Administrator/API] getOtherDataScenarioStatusList Failure',
  props<{ error: any }>()
);
//Action other Data material types
export const openAddEditScenarioStatusModal = createAction(
  '[Administrator/API] Open Add edi other data scenario Status Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditScenarioStatusModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data  scenario Status Modal success',
  props<{ scenarioStatusModalData?: any }>()
);

export const addEditOtherDataScenarioStatus = createAction(
  '[Administrator/API] Add edit other data Project Status ',
  props<{ scenarioStatusPayload: any }>()
);
export const addEditOtherDataScenarioStatusSuccess = createAction(
  '[Administrator/API] Add edit  other Project Status  success',
  props<{ scenarioStatusData: any }>()
);
export const addEditOtherDataScenarioStatusFailure = createAction(
  '[Administrator/API] Add edit other Project Status  failure',
  props<{ error: any }>()
);

// other Data EquivalancyUnitsList
export const getOtherDataEquivalancyUnitsList = createAction(
  '[Administrator/API] getOtherDataEquivalancyUnitsList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataEquivalancyUnitsListSuccess = createAction(
  '[Administrator/API] getOtherDataEquivalancyUnitsList Success',
  props<{ otherDataEquivalancyUnitsList: any }>()
);
export const getOtherDataEquivalancyUnitsListFailure = createAction(
  '[Administrator/API] getOtherDataEquivalancyUnitsList Failure',
  props<{ error: any }>()
);
//Action other EquivalancyUnits
export const openAddEditEquivalancyUnitsModal = createAction(
  '[Administrator/API] Open Add edi other data EquivalancyUnits Modal',
  props<{ actionLabel: any }>()
);
export const openAddEditEquivalancyUnitsModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data  EquivalancyUnits Modal success',
  props<{ equivalancyUnitsModalData?: any }>()
);

export const addEditOtherDataEquivalancyUnits = createAction(
  '[Administrator/API] Add edit other data EquivalancyUnits ',
  props<{ equivalancyUnitsPayload: any }>()
);
export const addEditOtherDataEquivalancyUnitsSuccess = createAction(
  '[Administrator/API] Add edit  other EquivalancyUnits  success',
  props<{ equivalancyUnitsData: any }>()
);
export const addEditOtherDataEquivalancyUnitsFailure = createAction(
  '[Administrator/API] Add edit other EquivalancyUnits  failure',
  props<{ error: any }>()
);
//Action for Conversion Mapping
export const getConversionMappingList = createAction(
  '[Administrator/API] Conversion Mapping',
  props<{ payload: any; pathName?: any }>()
);
export const getConversionMappingListSuccess = createAction(
  '[Administrator/API] Conversion Mapping Success',
  props<{ conversionMappingList: any }>()
);
export const getConversionMappingListFailure = createAction(
  '[Administrator/API] Conversion Mapping Failure',
  props<{ error: any }>()
);

export const openAddEditConversionMappingModal = createAction(
  '[Administrator/API] Open Add edit Conversion Mapping Modal',
  props<{
    id?: any;
    conversionProcessId?: any;
    actionLabel: any;
    pathName: any;
  }>()
);
export const openAddEditConversionMappingModalSuccess = createAction(
  '[Administrator/API] Open Add edit Conversion Mapping Modal success',
  props<{ conversionMappingModalData?: any }>()
);

export const addEditConversionMapping = createAction(
  '[Administrator/API] Add edit Conversion Mapping ',
  props<{ conversionMappingPayload: any }>()
);
export const addEditConversionMappingSuccess = createAction(
  '[Administrator/API] Add edit Conversion Mapping success',
  props<{ conversionMappingData: any }>()
);
export const addEditConversionMappingFailure = createAction(
  '[Administrator/API] Add edit Conversion Mapping failure',
  props<{ error: any }>()
);

export const deleteConversionMapping = createAction(
  '[Administrator/API] delete Mapping data',
  props<{ successMsg: any }>()
);

//Action for Reycled Content
export const getRecycledContentList = createAction(
  '[Administrator/API] Reycled Content',
  props<{ payload: any; pathName?: any }>()
);
export const getRecycledContentListSuccess = createAction(
  '[Administrator/API] Reycled Content Success',
  props<{ recycledContentList: any }>()
);
export const getRecycledContentListFailure = createAction(
  '[Administrator/API] Reycled Content Failure',
  props<{ error: any }>()
);

export const openAddEditRecycledContentModal = createAction(
  '[Administrator/API] Open Add edit Reycled Content Modal',
  props<{ id?: any; regionId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditRecycledContentModalSuccess = createAction(
  '[Administrator/API] Open Add edit Reycled Content Modal success',
  props<{ recycledModalData?: any }>()
);

export const addEditRecycledContent = createAction(
  '[Administrator/API] Add edit Reycled Content ',
  props<{ recycledPayload: any }>()
);
export const addEditRecycledContentSuccess = createAction(
  '[Administrator/API] Add edit Reycled Content success',
  props<{ recycledData: any }>()
);
export const addEditRecycledContentFailure = createAction(
  '[Administrator/API] Add edit Reycled Content failure',
  props<{ error: any }>()
);

export const deleteRecycledContent = createAction(
  '[Administrator/API] delete Mapping data',
  props<{ successMsg: any }>()
);

// other Data EquivalancyUnitsList
export const getOtherDataCountryIndetifiersList = createAction(
  '[Administrator/API] getOtherDataCountryIndetifiersList',
  props<{ payload: any; pathName?: any }>()
);
export const getOtherDataCountryIndetifiersListSuccess = createAction(
  '[Administrator/API] getOtherDataCountryIndetifiersList Success',
  props<{ otherDataCountryIndetifiersList: any }>()
);
export const getOtherDataCountryIndetifiersListFailure = createAction(
  '[Administrator/API] getOtherDataCountryIndetifiersList Failure',
  props<{ error: any }>()
);
//Action other EquivalancyUnits
export const openAddEditCountryIndetifiersModal = createAction(
  '[Administrator/API] Open Add edi other data CountryIndetifiers Modal',
  props<{
    countryIdentifierId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddEditCountryIndetifiersModalSuccess = createAction(
  '[Administrator/API] Open Add edit other data  CountryIndetifiers Modal success',
  props<{ countryIndetifiersModalData?: any }>()
);

export const addEditOtherDataCountryIndetifiers = createAction(
  '[Administrator/API] Add edit other data CountryIndetifiers ',
  props<{ countryIndetifiersPayload: any }>()
);
export const addEditOtherDataCountryIndetifiersSuccess = createAction(
  '[Administrator/API] Add edit  other CountryIndetifiers  success',
  props<{ countryIndetifiersData: any }>()
);
export const addEditOtherDataCountryIndetifiersFailure = createAction(
  '[Administrator/API] Add edit other CountryIndetifiers  failure',
  props<{ error: any }>()
);
//Action for EOL Product Package Ratio
export const getProductPackageRatioList = createAction(
  '[Administrator/API] Product Package Ratio',
  props<{ payload: any; pathName?: any }>()
);
export const getProductPackageRatioListSuccess = createAction(
  '[Administrator/API] Product Package Ratio Success',
  props<{ productPackageRatioList: any }>()
);
export const getProductPackageRatioListFailure = createAction(
  '[Administrator/API] Product Package Ratio Failure',
  props<{ error: any }>()
);

export const openAddEditProductPackageRatioModal = createAction(
  '[Administrator/API] Open Add edit Product Package Ratio Modal',
  props<{
    sectorIdentifierId?: any;
    regionId?: any;
    actionLabel: any;
    pathName: any;
  }>()
);
export const openAddEditProductPackageRatioModalSuccess = createAction(
  '[Administrator/API] Open Add edit Product Package Ratio Modal success',
  props<{ productPackageRatioData?: any }>()
);

export const addEditProductPackageRatio = createAction(
  '[Administrator/API] Add edit Product Package Ratio Modal',
  props<{ productPackageRatioPayload: any }>()
);
export const addEditProductPackageRatioSuccess = createAction(
  '[Administrator/API] Add edit Product Package Ratio Modal success',
  props<{ productPackageRatioData: any }>()
);
export const addEditProductPackageRatioFailure = createAction(
  '[Administrator/API] Add edit Product Package Ratio Modal failure',
  props<{ error: any }>()
);

// Processing Data  misc simulation
export const getMiscSimulationList = createAction(
  '[Administrator/API] getMiscSimulationList',
  props<{ payload: any; pathName?: any }>()
);
export const getMiscSimulationListSuccess = createAction(
  '[Administrator/API] getMiscSimulationList Success',
  props<{ miscSimulationList: any }>()
);
export const getMiscSimulationListFailure = createAction(
  '[Administrator/API] getMiscSimulationList Failure',
  props<{ error: any }>()
);
//Action for  misc simulation Modal
export const openAddMiscSimulationModal = createAction(
  '[Administrator/API] Open Add edit misc simulation Modal',
  props<{
    energyprocessId?: any;
    actionLabel: any;
    pathName: any;
    regionId: any;
  }>()
);
export const openAddMiscSimulationModalModalSuccess = createAction(
  '[Administrator/API] Open Add edit misc simulation Modal success',
  props<{ miscSimulationModalData?: any }>()
);
// add edit  misc simulation
export const addEditMiscSimulation = createAction(
  '[Administrator/API] Add edit misc simulation ',
  props<{ miscSimulation: any }>()
);
export const addEditMiscSimulationSuccess = createAction(
  '[Administrator/API] Add edit misc simulation success',
  props<{ miscSimulationData: any }>()
);
export const addEditMiscSimulationFailure = createAction(
  '[Administrator/API] Add edit misc simulation failure',
  props<{ error: any }>()
);
// get log entries
export const getLogEntriesList = createAction(
  '[Administrator/API] LogEntries List',
  props<{ payload: any; pathName?: any }>()
);
export const getLogEntriesListSuccess = createAction(
  '[Administrator/API] LogEntries List Success',
  props<{ logEntriesListData: any }>()
);
export const getLogEntriesListFailure = createAction(
  '[Administrator/API] LogEntries List Failure',
  props<{ error: any }>()
);

export const openAddEditlogEntryModal = createAction(
  '[Shared/API] Open Add edit log entries Modal',
  props<{
    id?: any;
    primaryId?: any;
    tableName?: any;
    actionLabel: any;
    pathName: any;
  }>()
);
export const openAddEditlogEntryModalSuccess = createAction(
  '[Shared/API] Open Add edit log entries Modal success',
  props<{ logEntriesData?: any }>()
);

//Action for Country Listing in Admin -> Advanced
export const getAdminCountryList = createAction(
  '[Administrator/API] Country Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminCountryListSuccess = createAction(
  '[Administrator/API] Country Listing Success',
  props<{ countryList: any }>()
);
export const getAdminCountryListFailure = createAction(
  '[Administrator/API] Country Listing Failure',
  props<{ error: any }>()
);

export const openAddCountryModal = createAction(
  '[Administrator/API] Open Add edit Country Listing Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openAddCountryModalSuccess = createAction(
  '[Administrator/API] Open Add edit Country Listing Modal success',
  props<{ countryModalData?: any }>()
);

export const addEditCountry = createAction(
  '[Administrator/API] Add edit Country Listing Modal',
  props<{ countryPayload: any }>()
);
export const addEditCountrySuccess = createAction(
  '[Administrator/API] Add edit Country Listing Modal success',
  props<{ countryPayload: any }>()
);
export const addEditCountryFailure = createAction(
  '[Administrator/API] Add edit Country Listing Modal failure',
  props<{ error: any }>()
);

//Action for State Listing in Admin -> Advanced
export const getAdminStateList = createAction(
  '[Administrator/API] State Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminStateListSuccess = createAction(
  '[Administrator/API] State Listing Success',
  props<{ stateList: any }>()
);
export const getAdminStateListFailure = createAction(
  '[Administrator/API] State Listing Failure',
  props<{ error: any }>()
);

export const openAddStateModal = createAction(
  '[Administrator/API] Open Add edit State Listing Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openAddStateModalSuccess = createAction(
  '[Administrator/API] Open Add edit State Listing Modal success',
  props<{ stateModalData?: any }>()
);

export const addEditState = createAction(
  '[Administrator/API] Add edit State Listing Modal',
  props<{ statePayload: any }>()
);
export const addEditStateSuccess = createAction(
  '[Administrator/API] Add edit State Listing Modal success',
  props<{ statePayload: any }>()
);
export const addEditStateFailure = createAction(
  '[Administrator/API] Add edit State Listing Modal failure',
  props<{ error: any }>()
);

//Action for City Listing in Admin -> Advanced
export const getAdminCityList = createAction(
  '[Administrator/API] City Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminCityListSuccess = createAction(
  '[Administrator/API] City Listing Success',
  props<{ cityList: any }>()
);
export const getAdminCityListFailure = createAction(
  '[Administrator/API] City Listing Failure',
  props<{ error: any }>()
);

export const openAddCityModal = createAction(
  '[Administrator/API] Open Add edit City Listing Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openAddCityModalSuccess = createAction(
  '[Administrator/API] Open Add edit City Listing Modal success',
  props<{ cityModalData?: any }>()
);

export const addEditCity = createAction(
  '[Administrator/API] Add edit City Listing Modal',
  props<{ cityPayload: any }>()
);
export const addEditCitySuccess = createAction(
  '[Administrator/API] Add edit City Listing Modal success',
  props<{ cityPayload: any }>()
);
export const addEditCityFailure = createAction(
  '[Administrator/API] Add edit City Listing Modal failure',
  props<{ error: any }>()
);

//Action for Import Listing in Admin -> Advanced
export const getAdminImportList = createAction(
  '[Administrator/API] Import Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminImportListSuccess = createAction(
  '[Administrator/API] Import Listing Success',
  props<{ importList: any }>()
);
export const getAdminImportListFailure = createAction(
  '[Administrator/API] Import Listing Failure',
  props<{ error: any }>()
);

//Action for News Listing in Admin -> Advanced
export const getAdminNewsList = createAction(
  '[Administrator/API] News Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminNewsListSuccess = createAction(
  '[Administrator/API] News Listing Success',
  props<{ newsList: any }>()
);
export const getAdminNewsListFailure = createAction(
  '[Administrator/API] News Listing Failure',
  props<{ error: any }>()
);

//Action for news Add Edit
export const openAddEditNewsModal = createAction(
  '[Administrator/API] Open Add edit news details Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openAddEditNewsModalSuccess = createAction(
  '[Administrator/API] Open Add edit news details Modal success',
  props<{ newsDetailsData?: any }>()
);

export const addEditNews = createAction(
  '[Administrator/API] Add edit News Modal',
  props<{ newsPayload: any }>()
);
export const addEditNewsSuccess = createAction(
  '[Administrator/API] Add edit News Modal success',
  props<{ newsPayload: any }>()
);
export const addEditNewsFailure = createAction(
  '[Administrator/API] Add edit News Modal failure',
  props<{ error: any }>()
);

//Action for Roles Listing in Admin -> Advanced
export const getAdminRolesList = createAction(
  '[Administrator/API] Roles Listing',
  props<{ payload: any; pathName?: any }>()
);
export const getAdminRolesListSuccess = createAction(
  '[Administrator/API] Roles Listing Success',
  props<{ rolesList: any }>()
);
export const getAdminRolesListFailure = createAction(
  '[Administrator/API] Roles Listing Failure',
  props<{ error: any }>()
);

export const openAddRolesModal = createAction(
  '[Administrator/API] Open Add edit Roles Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openAddRolesModalSuccess = createAction(
  '[Administrator/API] Open Add Roles Modal success',
  props<{ rolesDetailsData?: any }>()
);

export const addRole = createAction(
  '[Administrator/API] Add edit Role Modal',
  props<{ rolePayload: any }>()
);
export const addRoleSuccess = createAction(
  '[Administrator/API] Add edit Role Modal success',
  props<{ rolePayload: any }>()
);
export const addRoleFailure = createAction(
  '[Administrator/API] Add edit Role Modal failure',
  props<{ error: any }>()
);

//Action for opening Import in Admin -> Imports
export const openImportModal = createAction(
  '[Administrator/API] Open Imports Modal',
  props<{ id?: any; actionLabel: any }>()
);
export const openImportModalSuccess = createAction(
  '[Administrator/API] Open Imports Modal success',
  props<{ importsData?: any }>()
);

export const importFile = createAction(
  '[Administrator/API] Add Import Modal',
  props<{ importPayload: any }>()
);
export const importFileSuccess = createAction(
  '[Administrator/API] Add Import Modal success',
  props<{ importPayload: any }>()
);
export const importFileFailure = createAction(
  '[Administrator/API] Add Import Modal failure',
  props<{ error: any }>()
);

// Action for get state for city
export const getStateForCity = createAction('[Shared/API] getStateForCity', props<{ id: any }>());
export const getStateForCitySuccess = createAction(
  '[Shared/API] getStateForCity Success',
  props<{ stateList: any }>()
);
export const getStateForCityFailure = createAction(
  '[Shared/API] getStateForCity Failure',
  props<{ error: any }>()
);
